<sm-title-bar
  *ngIf="!loader"
  pageTitle="{{ 'employees.title' | translate }}"
  [backWithParams]="true"
  [headerCustomTemplate]="addButton"
>
<ng-template #addButton>

  <div class="create_btn_sd">
    <button mat-icon-button color="primary" (click)="employeeplan()" >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</ng-template>
</sm-title-bar>

<!-- 
<div class="stat-cards row row-cols-xl-4 row-cols-lg-3 g-4" *ngIf="employeeData.length > 0 && !loader">
  <div class="col" *ngFor="let item of employeeData">
    <mat-card (click)="viewDetails(item.employeeHashId)" class="stats_c">
      <mat-card-title-group class="align-items-center">
        <mat-card-title>{{item.name}}</mat-card-title>
        <mat-card-subtitle class="m-0">{{item.phone}}</mat-card-subtitle>
       
        <mat-card-subtitle style="margin-bottom: 0px; margin-top: 10px;">{{item.addressInfo}}</mat-card-subtitle>
        <mat-card-subtitle class="m-0">DOB: {{item.dob | date}}</mat-card-subtitle>
        <div class="card-icon d-flex justify-content-center align-items-center">
          <img [src]="item.imgThumbUrl" alt="" onerror="this.src='../../../../assets/images/salon_support_header.png'">
        </div>
      </mat-card-title-group>
    </mat-card>
  </div>
</div>
<ng-container *ngIf="employeeData.length == 0 && !loader">
  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
      <h3>
        {{ 'employees.no_employee_text' | translate }}
      </h3>
      <p>
        {{ 'employees.no_employee_subtext' | translate }}
      </p>
    </div>
  </div>   
</ng-container> -->

<section class="nw_service_th" *ngIf="!loader">
  <div class="service_se">
    <div class="row align-items-center">
      <div class="col-sm-9">
        <div class="chip_services_list">
          <mat-chip-listbox class="example-chip">
            <mat-chip
              (click)="selectChip(1)"
              [ngClass]="{ 'Graceful-box-active': selectedValue == 1 }"
              >Current employees</mat-chip
            >
            <mat-chip
              (click)="selectChip(2)"
              class="Beauty-box"
              [ngClass]="{ 'Graceful-box-active': selectedValue == 2 }"
              >Ex employees
            </mat-chip>
            <mat-chip
              (click)="selectChip(3)"
              class="Salon-box"
              [ngClass]="{ 'Graceful-box-active': selectedValue == 3 }"
              >Joining invitations</mat-chip
            >
          </mat-chip-listbox>
        </div>
      </div>
      <div class="col-sm-3">
       
      </div>
    </div>
  </div>

  <div class="service_create_sd">
    <div class="search-bar-custom">
      <!-- <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput placeholder="Search for services" />
        <button mat-icon-button matSuffix>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field> -->
    </div>
  </div>

  <div class="service_card_sedf" *ngIf="employeeData.length>0 && !hidediv">
    <!-- <div class="row"> -->
      <div *ngIf="selectedValue != 3">
        <div class="row">
          <div class="col-sm-6" *ngFor="let item of employeeData">
            <div class="serv_sect">
              <!-- (click)="viewDetails(item.employeeHashId)" -->
              <mat-card appearance="outlined" class="service-card" (click)="viewDetails(item.employeeHashId)">
                <mat-card-header class="hy_secf">
                  
                  <div class="employee_flex">
                  <div mat-card-avatar class="header-avatar" style="position: relative;">
                      <div class="active_user" *ngIf="selectedValue == 1 && item.status == 1"></div>
                    <div class="de_active_user" *ngIf="selectedValue == 1 && item.status == 0"></div>
                    <img
                    *ngIf="item.imgThumbUrl && item.imgThumbUrl != 'null'"
                      [src]="item.imgThumbUrl"
                      onerror="this.src='../../../../assets/images/user-avatar.svg'"
                      alt="Service image"
                    />
                    <div class="booking-initial" *ngIf="!item.imgThumbUrl || item.imgThumbUrl == 'null'">{{item.name.slice(0,1).toUpperCase()}}</div>
                  </div>

                  <div class="header_ftgt">
                    <h4>{{ item.name }}</h4>
                    <mat-card-subtitle>{{ item.country_code }} {{ item.phone }}</mat-card-subtitle>
                  </div>
                </div>

                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menu2"
                    (click)="$event.stopPropagation()"
                    class="more-button"
                    aria-label="More options"
                    *ngIf="selectedValue != 2">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu2="matMenu">
                    <button mat-menu-item (click)="viewDetails(item.employeeHashId)">
                      <mat-icon class="material-icons-outlined">info</mat-icon>
                      <span>View details</span>
                    </button>
                    <button mat-menu-item (click)="openMessages(item,$event)">
                      <mat-icon class="material-icons-outlined">chat</mat-icon>
                      <span>Send messages</span>
                    </button>
                  </mat-menu>
                </mat-card-header>
                <mat-card-content style="padding: 0px;">
                
                  <div class="location_list_s">
                    <div class="new_empol">
                      <p>
                        <mat-icon>location_on</mat-icon> {{ item.addressInfo }}
                      </p>
                    </div>
                    <div class="new_empol">
                     <p *ngIf="selectedValue == 1">
                        <mat-icon style="color: #434343">calendar_month</mat-icon>
                        {{ item.dateOfJoin | date }} (DOJ)
                      </p>
                      <p *ngIf="selectedValue == 2">
                        <mat-icon style="color: #434343">calendar_month</mat-icon>
                        Exited on: {{ item?.date_of_exit ?  (item?.date_of_exit | date) : '---' }}
                      </p>
                    </div>
                  </div>
                  <!-- <div class="chuo_list">
                    <div class="send_messages_btn">
                        <h3 (click)="openMessages(item,$event)">Send messages</h3>
                    </div>
                    <div class="onhover_arrow">
                        <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                   </div>
                </div> -->
                 <!-- <div class="subscription_status" *ngIf="selectedValue == 1">
                   <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                     <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                    </div> -->

                     <!-- <div class="chip_oper" (click)="$event.stopPropagation()">
                      <mat-accordion>
                 <mat-expansion-panel  (opened)="panelState[0] = true"
                                      (closed)="panelState[0] = false">
                   <mat-expansion-panel-header *ngIf="selectedValue == 1">
                     <mat-panel-title>
                    <div class="subscription_status"  >
                    <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                      <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                     </div>
                     <div class="jb_headingtert" *ngIf="selectedValue == 1">
                       <p> Jobs</p>
                     </div>
                     </mat-panel-title>
                    
                   </mat-expansion-panel-header>
                   <div *ngIf="item.assigned_slots">

                     <div class="main_time_till" *ngIf="selectedValue == 1">
                       <div class="time-pill" *ngFor="let item of item.formatted_assigned_slots">
                         <div class="count-circle">{{ item.count }}</div>
                         <div class="time-text">{{ item.start_time.slice(0,5) }} - {{ item.end_time.slice(0,5) }}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div *ngIf="!item.assigned_slots" style="display: flex;justify-content: center;color: grey;">
                      <p>No assigned jobs yet.</p>
                    </div>
                 </mat-expansion-panel>


                 </mat-accordion>

            </div> -->

  <div class="chip_oper" (click)="$event.stopPropagation()">
              <mat-accordion>
                <!-- (opened)="panelState[0] = true" (closed)="panelState[0] = false" -->
                 <mat-expansion-panel hideToggle >
                   <mat-expansion-panel-header>
                     <div class="emolpyee_down_list">
                        <div class="emplyee_listy" style="width: 215px;">
                     <mat-panel-title>
                    <div class="subscription_status"  >
                    <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                      <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                     </div>
                     <!-- <div class="jb_headingtert" >
                       <p> Jobs</p>
                     </div> -->
                     </mat-panel-title>
                     </div>
                     <div class="emplyee_listy">
                       <mat-panel-description>
                           Jobs ({{item.assigned_slots ? item.assigned_slots.length : 0}})
                           <mat-icon>keyboard_arrow_down</mat-icon>
                           </mat-panel-description>
                           </div>
                           </div>
                   </mat-expansion-panel-header>
                   <div *ngIf="item.assigned_slots">

                     <div class="main_time_till" >
                       <div class="time-pill" *ngFor="let item of item.formatted_assigned_slots">
                         <div class="count-circle">{{ item.count }}</div>
                         <div class="time-text">{{ item.start_time.slice(0,5) }} - {{ item.end_time.slice(0,5) }}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div *ngIf="!item.assigned_slots" style="display: flex;justify-content: left;color: grey;">
                      <p>No assigned jobs yet.</p>
                    </div>
                 </mat-expansion-panel>

 <!-- <mat-expansion-panel  hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
      <div class="subscription_status"  >
                    <p class="active_heading" *ngIf="item.subscriptionInfo">Active subscription</p>
                      <p class="expired_heading" *ngIf="!item.subscriptionInfo">Subscription expired</p>
                     </div>
      </mat-panel-title>
      <mat-panel-description>
       Assignments
        <mat-icon>keyboard_arrow_down</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
  <div *ngIf="item.assigned_slots">

                     <div class="main_time_till" >
                       <div class="time-pill" *ngFor="let item of item.formatted_assigned_slots">
                         <div class="count-circle">{{ item.count }}</div>
                         <div class="time-text">{{ item.start_time.slice(0,5) }} - {{ item.end_time.slice(0,5) }}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div *ngIf="!item.assigned_slots" style="display: flex;justify-content: center;color: grey;">
                      <p>No assigned jobs yet.</p>
                    </div>
 
  </mat-expansion-panel> -->

                 </mat-accordion>
            </div>

                </mat-card-content>
              </mat-card>
            </div>
          </div>

        </div>
      </div>
      <!-- invitation -->
      <div *ngIf="selectedValue == 3">
        <div class="row">
          <div class="col-sm-3" *ngFor="let item of employeeData">
            <div class="serv_sect">
              <!-- (click)="viewInvitationDetails(item.requestHashId)" -->
              <mat-card appearance="outlined" class="service-card"  >
                <mat-card-header class="hy_secf">
                  <div>
                    <div class="red_dot" *ngIf="item.requestStatus == 3 || item.requestStatus == 4"></div>
                    <div class="green_dot" *ngIf="item.requestStatus == 2"></div>
                    <div class="yellow_dot" *ngIf="item.requestStatus == 1"></div>
                    <div class="employee_flex">
                      <div mat-card-avatar class="header-avatar">
                        <img
                       *ngIf="item.imgThumbUrl && item.imgThumbUrl != 'null'"
                      [src]="item.imgThumbUrl"
                      onerror="this.src='../../../../assets/images/user-avatar.svg'"
                      alt="Service image"/>
                    <div class="booking-initial" *ngIf="!item.imgThumbUrl || item.imgThumbUrl == 'null'">{{item.toName.slice(0,1).toUpperCase()}}</div>
                      </div>
                      <div class="header_ftgt">
                        <h4>{{ item.toName }}</h4>
                        <mat-card-subtitle>{{ item.country_code }} {{ item.toPhone }}</mat-card-subtitle>
                      </div>
                    </div>
                  </div>
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menu2"
                    class="more-button"
                    aria-label="More options"
                    *ngIf="selectedValue != 2">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu2="matMenu">
                    <button
                      mat-menu-item
                      (click)="viewInvitationDetails(item.requestHashId)">
                      <mat-icon class="material-icons-outlined">info</mat-icon>
                      <span>View details</span>
                    </button>
                  </mat-menu>
                </mat-card-header>
                <mat-card-content style="padding: 0px;">
                  <div class="location_list_s">
                    <div class="new_empol">
                      <p>
                        <mat-icon>payments</mat-icon> {{item.currency_symbol}}{{ item.joiningSalary }}
                      </p>
                    </div>
                    <div class="new_empol">
                      <p>
                        <mat-icon style="color: #434343">calendar_month</mat-icon>
                        {{ item.creationDate | date }} 
                      </p>
                    </div>
                  </div>
                  <!-- <div class="chuo_list">
                    <div class="send_messages_btn">
                        <h3 (click)="openMessages(item,$event)">Send messages</h3>
                    </div>
                    <div class="onhover_arrow">
                        <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                   </div>
                </div> -->
                
                </mat-card-content>
              </mat-card>
            </div>
          </div>

        </div>
      </div>
    <!-- </div> -->
  </div>

  <div class="placeholder_started" *ngIf="employeeData.length == 0 && !hidediv">
    <div class="row">
  
      <div class="col-sm-4" *ngIf="selectedValue == 1 || selectedValue == 3 ">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
              <div class="upload_sectio">
          
             <div *ngIf="selectedValue == 1">
              <div class="icm_img">
                <img src="./assets/images/employee-paceholder.png">
             </div>
               <mat-card-title>No employees to show here</mat-card-title>
               <mat-card-content>All the active employees of this business will appear here. Start adding one now. Build your team to work together in sync. 
              </mat-card-content>

             </div>
             <div *ngIf="selectedValue == 3">
              <div class="icm_img">
                <!-- <img src="./assets/images/joining-invitation.png"> -->
                <img src="./assets/images/joining-invitation.png">

             </div>
               <mat-card-title>No joining invitations to show</mat-card-title>
               <mat-card-content>The business yet not invited anyone to join as an employee. All the invitations will appear here with the current status.
              </mat-card-content>

             </div>
            
             <div class="watch_vc_btn">
                <button mat-stroked-button color="primary" (click)="employeeplan()">
                   <mat-icon>add</mat-icon>
                   Add employee
                </button>
             </div>
             </div>
          </mat-card>
       </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
              <div class="upload_sectio">
          
             <div *ngIf="selectedValue == 1 || selectedValue == 3">
              <div class="icm_img">
                <!-- <img src="./assets/images/current-employer-placeholder.png">
                  -->
                  <img src="./assets/images/add-employee.png">
                  
             </div>
               <mat-card-title>How to add employee?</mat-card-title>
               <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on adding an employee in your business. You can check this video as well to get step by step help.
              </mat-card-content>

             </div>
             <div *ngIf="selectedValue == 2">
              <div class="icm_img">
                <img src="./assets/images/ex-employer-placeholder.png">
             </div>
               <mat-card-title>No ex-employee to show</mat-card-title>
               <mat-card-content>All the ex-employees of this business will appear here. It's good to keep the service and financial records. Also profile data can be used in communication further.
              </mat-card-content>

             </div>
             <!-- <div *ngIf="selectedValue == 3">
              <div class="icm_img">
                <img src="./assets/images/joining-invitation.png">
             </div>
               <mat-card-title>No joining invitations to show</mat-card-title>
               <mat-card-content>The business yet not invited anyone to join as an employee. You can invite one by clicking on the 'Add new employee' button top right. All the invitations will appear here with the current status. 
              </mat-card-content>

             </div> -->
             <div class="watch_vc_btn" *ngIf="selectedValue == 1 || selectedValue == 3">
                <button mat-stroked-button color="primary" (click)="openvideo()">
                   <mat-icon>play_arrow</mat-icon>
                   Watch video
                </button>
             </div>
             </div>
          </mat-card>
       </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card appearance="outlined">
              <div class="upload_sectio">
             <div class="icm_img">
                <img src="./assets/images/helpsupport.png">
             </div>
             <mat-card-title>Having any issue?</mat-card-title>
             <mat-card-content>For any difficulties in displaying data here or if there's any issue while adding employees, contact our support team.
            </mat-card-content>
             <div class="watch_vc_btn">
                <button mat-stroked-button color="primary" (click)="opencontact()">
                   <mat-icon>support_agent</mat-icon>
                   Contact support
                </button>
             </div>
             </div>
          </mat-card>
       </div>
      </div>
    </div>

  </div>
</section>
